import './Block.css'

const Block = ({ block, isActive }) => {
    
    // Determine the CSS classes based on block state
    const getBlockClasses = () => {
        let classes = ['block'];
        
        // Add filled class if there's a value
        if (block.value && !block.isInCorrectPlace && !block.charExistsInWord) {
            classes.push('filled');
        }
        
        // Add state classes
        if (block.isInCorrectPlace) {
            classes.push('correct');
        } else if (block.charExistsInWord) {
            classes.push('exists');
        } else if (block.value && !block.isInCorrectPlace && !block.charExistsInWord) {
            // Only add 'wrong' if the word has been submitted (would have either isInCorrectPlace or charExistsInWord set)
            // This prevents unsubmitted letters from being grayed out
        }
        
        // Add active class for current input position
        if (isActive) {
            classes.push('active');
        }
        
        return classes.join(' ');
    };
    
    return (
        <div className={getBlockClasses()}>
            {block.value}
        </div>
    )
}

export default Block;